module.exports = __webpack_public_path__ + "static/media/user_icon.b4831324.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user_icon.svg
// module id = 96
// module chunks = 0